/* DVWebNodeUtils: GetInvoices types */
import { RequestContext } from '../../types/request-context';
import { SettingsContent, SettingsContentTypes } from './settings';
import { DVString } from './shared';

export enum GISStatus {
    NOTREQUIRED = 'NOTREQUIRED',
    READY = 'READY',
    PENDING = 'PENDING',
    REQUEST = 'REQUEST',
    FAILED = 'FAILED'
}

export enum InvoiceType {
    CFDIPDF = 'CFDIPDF',
    CFDI = 'CFDI',
    NONGOV = 'NONGOV'
}

export interface Transaction {
    name: string,
    date: string,
    price?: string,
    token: string,
    orderId: string,
    docId: string,
    gisStatus: GISStatus,
    receipt: Invoice[],
    taxInvoice?: Invoice[],
    paymentComplement?: Invoice[],
    rfcErrorMessage?: DVString
}

export interface Invoice {
    id: string,
    transactionID: string,
    actionURL: string,
    name: string,
    type: InvoiceType,
}

export interface TimeOption {
    name: string,
    value: string,
    selected: boolean
}
export interface GetInvoicesOutput extends SettingsContent {
    __type: SettingsContentTypes.GetInvoicesOutput,
    transactions: Transaction[],
    hasRfcError: boolean,
    monthList: TimeOption[],
    yearList: TimeOption[],
    showInvoices: boolean,
    headers: string[],
    links: { [key: string]: string },
    strings: { [key: string]: string },
    rfcMessage?: {
        attrs:{
            amazonLink: {href: string}
        },
        string: string
    }
    iapMessage?: {
        header: string,
        message: string,
        link?: {
            text: string,
            href: string
        }
    }
}

export interface GetInvoicesInput {
    context: RequestContext,
    month: string,
    year: string,
    isSubscriptions?: boolean
}
